import { render, staticRenderFns } from "./DeviceInfoDisplay.vue?vue&type=template&id=2db9ed4c&scoped=true&"
import script from "./DeviceInfoDisplay.vue?vue&type=script&lang=ts&"
export * from "./DeviceInfoDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceInfoDisplay.vue?vue&type=style&index=0&id=2db9ed4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9ed4c",
  null
  
)

export default component.exports